// Explicit, account-independent entry points only. Never restore state.from,
// task URLs or arbitrary caller-supplied redirects across an account change.
export function signInModuleReturn(search) {
  const destinations = new URLSearchParams(search).getAll("returnTo");
  return destinations.length === 1 && destinations[0] === "/markdown-insights/"
    ? "/markdown-insights/"
    : null;
}
